import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FETCH_STATIONARY_BY_ID, GET_STATIONARY, GET_STATIONARY_CODE } from '../graphql/stationary.queries';
import { CREATE_STATIONARY, REMOVE_STATIONARY, UPDATE_STATIONARY } from '../graphql/stationary.mutation';

@Injectable({
  providedIn: 'root',
})
export class StationaryService {
  constructor(private apollo: Apollo) {}

  fetchStationary(search: string = ''): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_STATIONARY,
        variables: { search },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result.data?.stationories || []));
  }

   fetchSingleStationary(id: any): Observable<any> {
      return this.apollo
        .use('accounts')
        .query<any>({
          query: FETCH_STATIONARY_BY_ID,
          variables: {
            id
          },
          fetchPolicy: 'network-only',
        })
        .pipe(map((result) => result.data?.stationory || []));
    }

  createStationary(createStationoryInput: any): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: CREATE_STATIONARY,
      variables: {
        createStationoryInput: createStationoryInput,
      },
    });
  }

  updateStationary(stationaryData: any): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: UPDATE_STATIONARY,
      variables: {
        updateStationoryInput: stationaryData,
      },
    });
  }

  deleteStationaryById(id: number): Observable<any> {
    return this.apollo.use('accounts').mutate({
      mutation: REMOVE_STATIONARY,
      variables: { id },
    });
  }

  fetchStationaryCode(): Observable<any> {
    return this.apollo
      .use('accounts')
      .watchQuery<any>({
        query: GET_STATIONARY_CODE,
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(map((result) => result?.data?.generateStationoryCode));
  }
  
}
